import iframeSlice from './slice'

export const { setIsLoaded } = iframeSlice.actions

export default iframeSlice.reducer
